"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _MasterarbeitList = _interopRequireDefault(require("../MasterarbeitList/MasterarbeitList"));
var _Filter = _interopRequireDefault(require("../Filter/Filter"));
var _Pagination = _interopRequireDefault(require("../../Pagination/Pagination"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.SIAMasterarbeiten {\n  padding-inline: 0px; }\n\n@media (max-width: 66rem) {\n  .SIAMasterarbeiten {\n    padding-inline: 16px; } }\n";
  const fileName = "SIAMasterarbeiten_SIAMasterarbeiten";
  const element = document.querySelector("style[data-sass-component='SIAMasterarbeiten_SIAMasterarbeiten']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getFiltersString = (type, selectedFilters, page, itemsPerPage) => {
  const filters = [];
  if (selectedFilters.rank) {
    filters.push('rank=' + selectedFilters.rank.join(','));
  }
  if (selectedFilters.school) {
    filters.push('school=' + selectedFilters.school.join(','));
  }
  if (selectedFilters.year) {
    filters.push('year=' + selectedFilters.year.join(','));
  }
  if (selectedFilters.search) {
    filters.push('search=' + selectedFilters.search);
  }
  if (type) {
    filters.push('type=' + type);
  }
  if (page) {
    filters.push('page=' + page);
  }
  if (itemsPerPage) {
    filters.push('page_size=' + itemsPerPage);
  }
  return filters.join('&');
};
const SIAMasterarbeiten = _ref => {
  let {
    type,
    translate,
    cmsAdapter,
    lang
  } = _ref;
  const [actualFilterString, setActualFilterString] = (0, _react.useState)(undefined);
  const [page, setPage] = (0, _react.useState)(1);
  const [count, setCount] = (0, _react.useState)();
  const [itemsPerPage, setItemsPerPage] = (0, _react.useState)(20);
  const [listItems, setListItems] = (0, _react.useState)([]);
  const [filters, setFilters] = (0, _react.useState)();
  const [selectedFilters, setSelectedFilters] = (0, _react.useState)({});
  const [activeFilters, setActiveFilters] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    getFiltersFunc();
  }, []);
  const getFiltersFunc = async () => {
    const data = await cmsAdapter.fetchMasterarbeitenFilters(lang);
    setFilters(data);
  };
  (0, _react.useEffect)(() => {
    filters != {} && getItemsFunc();
  }, [filters, selectedFilters, page, itemsPerPage]);
  const getItemsFunc = async () => {
    const filtersString = getFiltersString(type, selectedFilters, page, itemsPerPage);
    if (actualFilterString !== undefined && filtersString === actualFilterString) return;
    setActualFilterString(filtersString);
    const data = await cmsAdapter.fetchMasterarbeiten(lang, filtersString);
    setListItems(data.items);
    setCount(data.count);
    setActiveFilters(data.active_filters);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `SIAMasterarbeiten`
  }, filters && /*#__PURE__*/_react.default.createElement(_Filter.default, {
    translate: translate,
    filters: filters,
    onChange: v => {
      setSelectedFilters(v);
      setPage(1);
    },
    activeFilters: activeFilters
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-top"
  }, /*#__PURE__*/_react.default.createElement(_MasterarbeitList.default, {
    items: listItems,
    lang: lang
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-12 sia-padding-02-top"
  }, /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    items: Array.from({
      length: count
    }, (v, i) => i),
    onChange: (newPage, perPageLimit) => {
      setPage(newPage);
      setItemsPerPage(perPageLimit);
    },
    translate: translate,
    page: page
  })));
};
var _default = exports.default = SIAMasterarbeiten;